var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#F0F0F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4350_53497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2218 5.58091L16.0196 3H4.83148C4.37179 3 4 3.34986 4 3.78243V19.2176C4 19.6501 4.37179 20 4.83148 20H19.1685C19.6282 20 20 19.6501 20 19.2176V7.66664L18.2206 5.58091H18.2218ZM18.337 18.4351H5.66295V4.56486H14.89V7.27431C14.89 7.7773 15.3235 8.18529 15.8581 8.18529H18.337V18.4351Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33087 15.8979C8.12419 15.8979 7.92938 15.8107 7.79753 15.6475C7.64906 15.4642 7.57066 15.1568 7.79753 14.8449C7.92463 14.6706 8.19308 14.4828 8.53517 14.295C8.8939 13.7663 9.40704 12.8933 9.95462 11.7823C10.564 10.546 10.9084 9.6496 11.07 9.09408C10.9013 8.79564 10.8146 8.55196 10.8087 8.3653C10.7944 7.94726 11.1056 7.63428 11.5475 7.62087C11.9324 7.60969 12.2412 7.84107 12.3374 8.21105C12.3837 8.38989 12.3754 8.63021 12.3255 8.91077C13.0097 9.87651 14.5693 11.5286 15.3949 12.2082C15.535 12.2115 15.6586 12.226 15.7607 12.254C16.1788 12.3691 16.3368 12.6743 16.3451 12.9213C16.357 13.2924 16.079 13.5808 15.6989 13.5919C15.6015 13.5953 15.4246 13.5998 15.0231 13.3404C14.466 13.4097 13.4195 13.6445 11.9941 14.1128C10.8027 14.504 9.9083 14.8718 9.3619 15.1378C9.10414 15.4798 8.85826 15.7336 8.65039 15.8275C8.54586 15.8744 8.43658 15.8968 8.33206 15.8968L8.33087 15.8979ZM11.9133 10.2767C11.652 10.9585 11.3123 11.6895 10.9916 12.3345C10.8253 12.6687 10.6198 13.0699 10.3941 13.4813C10.8431 13.3136 11.2577 13.1717 11.5511 13.0755C12.1842 12.8665 13.0739 12.5927 13.897 12.4094C13.6107 12.1366 13.2793 11.8013 12.8933 11.3888C12.5156 10.9842 12.1889 10.6131 11.9133 10.2778V10.2767Z",
    fill: "#454545"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4350_53497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 17,
    fill: "white",
    transform: "translate(4 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/icon_pdf.677901460914ec06c735cd8263c2a392.svg";
export { ForwardRef as ReactComponent };